import React from 'react';
import { Segment } from 'components';
import RiskProfilePage from './RiskProfilePage';

function RiskQuestionnairePage() {
  return (
    <Segment style={{ minHeight: '100%' }}>
      <RiskProfilePage />
    </Segment>
  );
}

export default RiskQuestionnairePage;
